import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMatLuminors: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 添加型号弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
